import {CommonMessages} from '../common.messages';

export const ExchangeAddMessages = {
    ExchangeCreationFailed: {
        key: 'ExchangeCreationFailed',
        message: 'Error while processing request. Unable to create a Exchange.'
    },
    ExchangeListFailed: {
        key: 'ExchangeListFailed',
        message: 'Error while processing request. Unable to list Exchange.'
    },
    ExchangeListDeletableFailed: {
        key: 'ExchangeListDeletableFailed',
        message: 'Error while processing request. Unable to list deletable Exchanges.'
    },
    ExchangeNoDeletableData: {
        key: 'ExchangeNoDeletableData',
        message: 'There are no deletable Exchanges! All of them may have been assigned to a feed.'
    },
    ExchangeCreationSucceed: {
        key: 'ExchangeCreationSucceed',
        message: 'Exchange is successfully created.'
    },
    ExchangeDeletionFailed: {
        key: 'ExchangeDeletionFailed',
        message: 'Error while processing request. Unable to delete a Exchange.'
    },
    ExchangeDeletionSucceed: {
        key: 'ExchangeDeletionSucceed',
        message: 'Exchange is successfully deleted.'
    },
    ExchangeUpdateFailed: {
        key: 'ExchangeUpdateFailed',
        message: 'Error while processing request. Unable to update a Exchange.'
    },
    ExchangeUpdateSucceed: {
        key: 'ExchangeUpdateSucceed',
        message: 'Exchange is successfully updated.'
    },
    ...CommonMessages
};
